export const LOCAL_STORAGE = {
  BUSINESS_VALUES: 'BUSINESS_VALUES',
  BUSINESS_DETAILS: 'BUSINESS_DETAILS',
  BUSINESSID: 'BUSINESSID',
  ISFREEMIUM: 'ISFREEMIUM',
  LIVE_CATALOGUE_ID: 'LIVE_CATALOGUE_ID',
  CURRENCY: 'CURRENCY',
  VERTICAL: 'VERTICAL',
  ORDERID: 'ORDERID',
  PAYMENT_GATEWAY: 'PAYMENT_GATEWAY',
  CURRENCY_SYMBOL: 'CURRENCY_SYMBOL',
  CUSTOMER_DETAILS: 'CUSTOMER_DETAILS',
  CUSTOMER_ID: 'CUSTOMER_ID',
  THANK_YOU_PAGE: 'THANK_YOU_PAGE',
  SAVED_CARDS: 'SAVED_CARDS',
  IS_TNC_ACCEPTED: 'IS_TNC_ACCEPTED',
  PARTICIPANT_SESSION_ID: 'PARTICIPANT_SESSION_ID',
  BUSINESS_ID: 'BUSINESS_ID',
  MERCHANT_ID: 'MERCHANT_ID',
  TRACKING: 'TRACKING',
  TRACKINGID: 'TRACKINGID',
  SESSION_ID: 'SESSION_ID',
  TEST_BUSINESSES: 'TEST_BUSINESSES',
  THEME: 'THEME'
};
